import { useEffect, useState } from "react";
import { useSearchParams, Link, useLocation } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2, Anchor } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Bubbles } from "@/components/Motifs";
import api from "@/lib/api";

export default function PaymentResult() {
  const [params] = useSearchParams();
  const location = useLocation();
  const isCancel = location.pathname.includes("cancel");
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState(isCancel ? "cancelled" : "checking");
  const [kind, setKind] = useState("lesson");

  useEffect(() => {
    if (isCancel || !sessionId) return;
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setKind(data.kind || "lesson");
        if (data.payment_status === "paid") return setStatus("paid");
        if (["failed", "expired"].includes(data.payment_status)) return setStatus("failed");
      } catch (e) { console.debug("payment status poll retry", e?.message); }
      if (++tries < 10) setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
  }, [sessionId, isCancel]);

  return (
    <div className="min-h-screen grid place-items-center bg-navy relative overflow-hidden px-6">
      <Bubbles count={18} dark />
      <div className="relative z-10 w-full max-w-lg rounded-3xl bg-cream p-10 text-center shadow-2xl">
        <img src="/assets/logo.png" alt="Float Now" className="h-20 w-20 object-contain mx-auto mb-4" />
        {status === "checking" && (<><Loader2 className="mx-auto text-teal animate-spin" size={48} /><h1 className="mt-5 font-serif text-3xl text-navy">Confirming your payment…</h1><p className="mt-2 text-navy/60">Just a moment while we secure your spot.</p></>)}
        {status === "paid" && (<><CheckCircle2 className="mx-auto text-teal" size={56} /><h1 className="mt-5 font-serif text-3xl text-navy">{kind === "package" ? "Your package is ready!" : "Your lesson is confirmed!"}</h1><p className="mt-3 text-navy/70">A confirmation email is on its way. We can't wait to make water safety a magical adventure.</p><Button asChild className="mt-7 rounded-full bg-coral hover:bg-[#C95B50] text-white px-8" data-testid="payment-dashboard"><Link to="/dashboard">Go to My Dashboard</Link></Button></>)}
        {status === "cancelled" && (<><XCircle className="mx-auto text-coral" size={56} /><h1 className="mt-5 font-serif text-3xl text-navy">Payment cancelled</h1><p className="mt-3 text-navy/70">No charge was made. You can pick up right where you left off.</p><Button asChild className="mt-7 rounded-full bg-navy text-cream px-8" data-testid="payment-retry"><Link to="/book"><Anchor size={16} className="mr-2" />Back to Booking</Link></Button></>)}
        {(status === "failed" || status === "timeout") && (<><XCircle className="mx-auto text-coral" size={56} /><h1 className="mt-5 font-serif text-3xl text-navy">We couldn't confirm the payment</h1><p className="mt-3 text-navy/70">If you were charged, it will appear in your dashboard shortly. Otherwise please try again.</p><Button asChild className="mt-7 rounded-full bg-navy text-cream px-8"><Link to="/book">Back to Booking</Link></Button></>)}
      </div>
    </div>
  );
}
